import React,{useEffect} from 'react';
import {useNavigate} from 'react-router-dom'
import { userLogout } from 'proxyUrl';
import axios from 'axios';

const SignOut = () => {

    const navigate = useNavigate();

    useEffect(()=>{
        axios.get(userLogout,{
            withCredentials:true
        } ).then((res) =>{
            navigate('/',{replace:true});
            if(res.status !== 200){
                const error = new Error(res.error); 
                throw error;
            }
        }).catch((err) =>{
            console.log(err);   
        })
    })
    return (
        <>
        <div className="w-full h-screen flex items-center justify-center">
            <h1 className='text-4xl'>Logging Out.....</h1>
        </div>
        
        </>
    );
}

export default SignOut;
